import { useGetEuroFxQuery } from '../types/generated';

export function useConvertCurrency() {
  const fxRates = useGetEuroFxQuery();

  function convert(amount: number, toCurrency: string) {
    if (toCurrency === 'EUR') return amount;

    // https://linear.app/avantarte/issue/PTE-3217/us-ddp-avant-arte
    // Switching to DDP means we take on the risk of any incorrectly charged
    // duties (typically ~10%). To offset this, SLT has approved a 10% markup
    // on the EUR to USD currency conversion in Shopify. U.S. buyers will only
    // see the final USD price; the markup won’t be referenced.
    const fxConversionMarkup = toCurrency === 'USD' ? 1.1 : 1.0;
    const rate = fxRates.data?.euroFx.find(
      (dailyRate) => dailyRate.currency === toCurrency,
    );

    if (!rate) {
      console.warn(`Unable to find exchange rate for EUR-${toCurrency}`);
      return amount;
    }

    return amount * rate.value * fxConversionMarkup;
  }

  return {
    convert,
    loading: fxRates.loading,
  };
}
